import moment from 'utils/moment';

/**
 * Du doan cac buoi lap ma server se tao ra.
 *
 * Phai khop voi AppointmentRepeatPlanner ben BE: horizon 6 thang ke tu buoi goc, toi da 12
 * buoi. Doi mot trong hai con so nay thi phai doi ca hai dau, neu khong ban xem truoc se noi
 * doi.
 *
 * Day chi la ban xem truoc. Server moi la ben quyet dinh, va no con bo qua nhung buoi trung
 * lich tho — thu ma FE khong the biet truoc. Vi vay so buoi that su tao ra co the it hon.
 */
export const REPEAT_HORIZON_MONTHS = 6;
export const REPEAT_MAX_OCCURRENCES = 12;

/**
 * Cong theo ngay lich (khong phai theo mili-giay) de giu nguyen gio dia phuong khi vuot qua
 * moc doi gio mua he, giong Calendar.add(DATE) ma BE dung.
 */
export const planOccurrences = (
  firstStart: moment.Moment | null | undefined,
  dayRepeat: number | null | undefined,
): moment.Moment[] => {
  if (!firstStart || !dayRepeat || dayRepeat <= 0) return [];

  const horizon = firstStart.clone().add(REPEAT_HORIZON_MONTHS, 'months');
  const occurrences: moment.Moment[] = [];

  for (let index = 1; index <= REPEAT_MAX_OCCURRENCES; index++) {
    const occurrence = firstStart.clone().add(index * dayRepeat, 'days');
    if (occurrence.isAfter(horizon)) break;
    occurrences.push(occurrence);
  }

  return occurrences;
};
